import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { ComponentStoreHelpers } from './helpers/ComponentStoreHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { AjaxCallHelpers } from './helpers/AjaxCallHelpers';
import { LabelAndPopover } from './components/label-and-popover';
import { PropertyHelpers } from '../helpers/PropertyHelpers';

export interface SwitchState {
    dataSourceCounter: number;
    timer: any;
    label: string;
}

class Switch extends React.Component<FormControlProps, SwitchState> {
    constructor(props: FormControlProps) {
        super(props);
        
        this.state = {
            dataSourceCounter: 0,
            timer: undefined,
            label: undefined,
        };

    }

    changeValidationError = () => {
        if (this.props.formFieldDefinition.validation &&
            this.props.formFieldDefinition.validation.required) {
            if (this.props.formConfig.algemenevoorwaardenLinkTekst) {
                const errorLabel = this.props.formFieldDefinition.validation.required.error.replace('[ALGEMENEVOORWAARDEN]', 
                    this.props.formConfig.algemenevoorwaardenLinkTekst);
                this.props.formFieldDefinition.validation.required.error = errorLabel;
            }            
        }
    }

    componentDidMount() {
        this.changeValidationError();

        if (ComponentStoreHelpers.hasDatasource(this)) {
            ComponentStoreHelpers.getData(this).then((data) => 
            {
                if(data && !this.unmounted) {
                    this.setState({label: (data as any).ShortText});
                }
            });
        }
    }

    unmounted : boolean = false;
    componentWillUnmount() {
        this.unmounted = true;
    }

    render() {
        let label: string = this.state.label ? this.state.label : this.props.formFieldDefinition.optionyes;
        let linkAlgemeneVoorwaarden = null;
        let self = this;
        let dontRenderLabelAboveInput = false;

        const fieldProperties = {
            ...FormControlHelpers.inputProperties(this),
            // Override
            onChange(e) {
                // don't call e.preventDefault() here .. it causes bug in lid-worden-form
                if (self.props.formFieldDefinition.clearFields !== undefined) {
                    self.props.formFieldDefinition.clearFields.map((fieldName: string) => {
                        self.props.formikBag.setFieldValue(fieldName, '');
                    });
                }
                self.props.formikBag.setFieldValue(self.props.formFieldDefinition.name, e.target.checked);
                self.props.field.onChange(e);

                setTimeout(() => {
                    if (FormControlHelpers.isValid(self)) {
                        // Only get data when input is valid
                        AjaxCallHelpers.getRelatedData(self as any, e.target.value);
                    }
                }, 1);
                
                return false;
                
            }
        };

        let isRequired = this.props.formFieldDefinition.validation['required'] !== undefined;

        if (this.props.formFieldDefinition.optionyes.indexOf('[ALGEMENEVOORWAARDEN]') >= 0) {
            label = label.replace('[ALGEMENEVOORWAARDEN]', '');
            dontRenderLabelAboveInput = true;
            linkAlgemeneVoorwaarden = (
                <>
                    <a
                        className="form__algemene-voorwaarden-link"
                        href={this.props.formConfig.algemenevoorwaarden}
                        target="_blank"
                    >
                        {ReactHtmlParser(this.props.formConfig.algemenevoorwaardenLinkTekst)}
                    </a>
                    <span>{isRequired ? " *" : ""}</span>
                </>
            );
        } else {
            linkAlgemeneVoorwaarden = <span>{isRequired ? " *" : ""}</span>;
        }
        
        const disabled = !!this.props.formFieldDefinition.readOnly;

        return (
            <div className={'form-group' + this.props.visibilityClass + ' ' + Slug.fromString(this.props.formFieldDefinition.name) + "-checkbox-form-group"}>
               {((!dontRenderLabelAboveInput && 
                label !== this.props.formFieldDefinition.label && 
                this.props.formFieldDefinition.label != '') || 
                (!!this.props.formFieldDefinition.hasPopover)) ? (
                    <LabelAndPopover 
                        className="form__checkbox"
                        fieldId={PropertyHelpers.getFieldID(this.props)} 
                        label={FormLabelHelpers.getFieldLabel(this)}
                        explanation={this.props.formFieldDefinition.explanation}
                        hasPopover={this.props.formFieldDefinition.hasPopover}                    
                    ></LabelAndPopover>
                ) : null}
                <div className="switch switch-sm">
                    <input
                        {...fieldProperties}
                        checked={this.props.field.value === true || this.props.field.value == "true"}
                        className={"switch " +  FormStylingHelpers.getCheckboxStyle(this)}
                        type="checkbox"
                        disabled={disabled}
                        value={this.props.formFieldDefinition.valueyes}
                        id={this.props.formFieldDefinition.name + "-" + this.props.formController.props.formName}
                    />
                    <label
                        htmlFor={this.props.formFieldDefinition.name + "-" + this.props.formController.props.formName}
                        className="custom-control-label"
                    >
                        {ReactHtmlParser(label)} {linkAlgemeneVoorwaarden}
                    </label>
                </div>
                {FormControlHelpers.invalidFeedbackComponent(this)}
            </div>
        );
    }
}

export { Switch };
